export const INVALID_ORDER_VERSION_ERROR_TITLE = 'Update your cart';
export const ADD_ITEM_CART_ERROR_TITLE = 'Error while adding product';
export const LOGO_UPLOAD_ERROR_TITLE = 'Oops...';
export const SUPER_SPEED_ERROR_TITLE = 'Super Speed option is unavailable!';
export const DEFAULT_ERROR_MESSAGE = 'Please try again, or contact us if you keep seeing this error.';
export const LOGO_UPLOAD_ERROR_MESSAGE = 'There was an error during your logo upload. Please try again, or contact us if you keep seeing this error.';
export const LOGO_UPLOAD_SIZE_LIMIT_ERROR_MESSAGE = "You've exceeded file maximum size limit in 10mb.";